import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { ButtonGroup } from '../../ButtonGroup/rn';
import { RichText } from '../../RichText/rn';
import { Milestone } from './Milestone';
import ArrowDownSvg from '../../../assets/images/rn/ArrayDown';
import { useTracking } from '../../../hooks/rn/useTracking';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export var TimelineCard = function TimelineCard(props) {
  var title = props.title,
    milestones = props.milestones,
    buttonGroup = props.buttonGroup,
    disabled = props.disabled,
    topPartRichTextSize = props.topPartRichTextSize,
    milestoneRichtextSizes = props.milestoneRichtextSizes,
    debounceSizeChange = props.debounceSizeChange,
    onWebViewSizeChange = props.onWebViewSizeChange;
  var hasActionButton = buttonGroup != null && buttonGroup.buttons.length > 0;
  var showMilestoneCount = computeDefaultMilestoneShowCount(milestones);
  var _useState = useState(showMilestoneCount < milestones.length),
    _useState2 = _slicedToArray(_useState, 2),
    collapse = _useState2[0],
    setCollapse = _useState2[1];
  var showMilestones = !collapse ? milestones : milestones.slice(0, showMilestoneCount);
  var _useTracking = useTracking(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var handleCollapse = function handleCollapse() {
    setCollapse(!collapse); // 点击埋点

    trackingClick && tracker.click(trackingClick);
  };
  return /*#__PURE__*/React.createElement(View, {
    style: style['timeline-card']
  }, /*#__PURE__*/React.createElement(RichText, _extends({}, title, {
    className: "timeline-card-content",
    classNameStyles: {
      'timeline-card-content': style['timeline-card-content']
    },
    disableSpecialLink: disabled,
    richTextSize: topPartRichTextSize,
    showLoading: false,
    debounceSizeChange: debounceSizeChange,
    onWebViewSizeChange: onWebViewSizeChange
  })), /*#__PURE__*/React.createElement(Milestone, {
    milestones: showMilestones,
    milestoneRichtextSizes: milestoneRichtextSizes,
    disabled: disabled,
    noBottomPadding: collapse || hasActionButton,
    debounceSizeChange: debounceSizeChange
  }), collapse ? hasActionButton ? /*#__PURE__*/React.createElement(View, _extends({
    style: style['timeline-card-collapse__has-action']
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(View, {
    style: style['has-action-line']
  }), /*#__PURE__*/React.createElement(Pressable, {
    onPress: handleCollapse
  }, /*#__PURE__*/React.createElement(ArrowDownSvg, {
    style: style['has-action-collapse']
  })), /*#__PURE__*/React.createElement(View, {
    style: style['has-action-line']
  })) : /*#__PURE__*/React.createElement(View, _extends({
    style: style['timeline-card-collapse__not-has-action']
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(Pressable, {
    onPress: handleCollapse
  }, /*#__PURE__*/React.createElement(ArrowDownSvg, {
    pathColor: "#ee4d2d"
  }))) : null, hasActionButton ? /*#__PURE__*/React.createElement(ButtonGroup, _extends({}, buttonGroup, {
    disabled: disabled
  })) : null);
};
var NoFutureShowMilestoneCount = 2;
function computeDefaultMilestoneShowCount(milestones) {
  var total = milestones.length;
  var futureLen = milestones.filter(function (v) {
    return v.isFuture;
  }).length;
  return Math.min(futureLen === 0 ? NoFutureShowMilestoneCount : futureLen + 1, total);
}
var style = CustomStyleSheet({
  'timeline-card': {
    maxWidth: '100%',
    paddingBottom: 6
  },
  'timeline-card-content': {
    paddingTop: 12,
    paddingRight: 12,
    paddingBottom: 12,
    paddingLeft: 12 // box-shadow: inset 0px -0.5px 0px rgba(0, 0, 0, 0.09);
  },

  'timeline-card-collapse__has-action': {
    width: '100%',
    height: 16,
    alignItems: 'center',
    flexDirection: 'row'
  },
  'has-action-line': {
    borderWidth: 0.5,
    borderColor: 'rgba(0, 0, 0, 0.09)',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0
  },
  'has-action-collapse': {
    width: 28,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  'timeline-card-collapse__not-has-action': {
    width: '100%',
    height: 36,
    borderRadius: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center' // box-shadow: inset 0px 0.5px 0px rgba(0, 0, 0, 0.09);
  }
});